__turbopack_context__.v({
  "actionsRow": "TripDrawer-module__XWG91a__actionsRow",
  "boldText": "TripDrawer-module__XWG91a__boldText",
  "buttonGroup": "TripDrawer-module__XWG91a__buttonGroup",
  "container": "TripDrawer-module__XWG91a__container",
  "content": "TripDrawer-module__XWG91a__content",
  "emailMeLabel": "TripDrawer-module__XWG91a__emailMeLabel" + " " + __turbopack_context__.i(942504)["saveButton"] + " " + __turbopack_context__.i(942504)["noUnderline"],
  "error": "TripDrawer-module__XWG91a__error",
  "errorContainer": "TripDrawer-module__XWG91a__errorContainer",
  "errorIcon": "TripDrawer-module__XWG91a__errorIcon",
  "failedTripIcon": "TripDrawer-module__XWG91a__failedTripIcon",
  "failedTripNotification": "TripDrawer-module__XWG91a__failedTripNotification",
  "footer": "TripDrawer-module__XWG91a__footer",
  "header": "TripDrawer-module__XWG91a__header",
  "justifyEnd": "TripDrawer-module__XWG91a__justifyEnd",
  "loadingBarContainer": "TripDrawer-module__XWG91a__loadingBarContainer",
  "noBorder": "TripDrawer-module__XWG91a__noBorder",
  "reverseButton": "TripDrawer-module__XWG91a__reverseButton",
  "successContainer": "TripDrawer-module__XWG91a__successContainer",
  "title": "TripDrawer-module__XWG91a__title",
  "titleUnderActions": "TripDrawer-module__XWG91a__titleUnderActions",
  "tripCaption": "TripDrawer-module__XWG91a__tripCaption",
});
